import React, { useEffect } from 'react';
import isbot from 'isbot';
import noop from 'shared/lib/noop';
import useConfirmModal from 'shared/hooks/useComfirmModal';
import CookieConsent from 'shared/components/CookieConsent';
import { DEFAULT_LANGUAGE_CODE } from 'shared/constants';

const useCookieConsent = ({
  apiClient,
  language = DEFAULT_LANGUAGE_CODE,
  onChangeLanguage = noop,
  runOnMount = noop
}) => {
  const handleConsentSubmit = closeModal => (data) => {
    localStorage.setItem('cookies.consented', '1');
    localStorage.setItem('cookies.analytics', data.analytics ? '1' : '');
    localStorage.setItem('cookies.marketing', data.marketing ? '1' : '');
    setTimeout(() => runOnMount(data.analytics, data.marketing));
    try {
      if (apiClient) {
        apiClient.post('/cookies', data);
      }
    } catch {}
    closeModal();
  };

  const { modalComponent, open } = useConfirmModal({
    renderContent: ({ close }) => (
      <CookieConsent
        language={language}
        onChangeLanguage={onChangeLanguage}
        onSubmit={handleConsentSubmit(close)}
      />
    ),
    noContentMargin: true,
    size: 'xl',
    wrapperClassName: 'cookie-banner'
  });

  useEffect(() => {
    const isBot = isbot(window.navigator.userAgent) || !window.navigator.userAgent;
    const consented = !!localStorage.getItem('cookies.consented') || isBot;

    if (!consented) {
      open();
      return;
    }

    const analytics = !!localStorage.getItem('cookies.analytics');
    const marketing = !!localStorage.getItem('cookies.marketing');

    setTimeout(() => runOnMount(analytics, marketing));
  }, []);

  return modalComponent;
};

export default useCookieConsent;
